import type { JobCardDataFragment } from '../../graphQL/fragments/__generated__/jobCardData.gqlgenerated';

/**
 * JobCardData with brandingEligibility field from GraphQL.
 * This matches the actual GraphQL schema which allows nulls in the brandingAttribution array
 * and null sourceType values.
 */
export type JobCardDataWithBrandingEligibility = JobCardDataFragment & {
    brandingEligibility?: {
        shouldShowBranding?: boolean | null;
        brandingInformation?: {
            localizedAssets?: {
                logo?: { url?: string | null } | null;
                banner?: { url?: string | null } | null;
            } | null;
        } | null;
        brandingAttribution?: Array<{ sourceType?: string | null } | null> | null;
    } | null;
};

/**
 * Clean branding attribution array by removing null elements and null sourceType values.
 * This type guard narrows the type to Array<{ sourceType: string }> which is what
 * mapBrandingAttributionToReasons expects.
 */
export function filterValidBrandingAttribution(
    attribution?: Array<{ sourceType?: string | null } | null> | null,
): Array<{ sourceType: string }> | undefined {
    if (!attribution) return undefined;
    return attribution.filter((attr): attr is { sourceType: string } => attr?.sourceType != null);
}
